<template>
  <a-spin :spinning="confirmLoading">
      <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-row>
          <a-col :span="24">
            <a-form-item label="机构名称">
              <a-input :max-length="32" placeholder="请输入机构名称"
                       v-decorator="['organizationName',{rules: [{required: true,message: '请输入机构名称'}]}]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="联系人">
              <a-input :max-length="32" placeholder="请输入联系人"
                       v-decorator="['customerRelation']"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="客户经理">
              <a-input :max-length="32" placeholder="请输入客户经理"
                       v-decorator="['customerManager']"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="会员等级">
              <a-select style="width: 155px" placeholder="请选择会员等级"
                        v-decorator="['memberGroupId',{rules: [{required: true,message: '请选择会员等级'}]}]"
              >
                <a-select-option v-for="item in groupList" :key="item.id" :value="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="会员开通时间" >
              <a-date-picker size="large" style="width: 500px" format="YYYY-MM-DD HH:mm:ss" :show-time="{ format: 'HH:mm:ss' }"
                             v-decorator="['memberCreateTime',{rules: [{required: true,message: '请选择会员开通时间'},{validator: this.startTimeValidate}]}]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="会员到期时间" >
              <a-date-picker size="large" style="width: 500px" format="YYYY-MM-DD HH:mm:ss" :show-time="{ format: 'HH:mm:ss' }"
                             v-decorator="['memberEffectiveTime',{rules: [{required: true,message: '请选择会员到期时间'},{validator: this.endTimeValidate}]}]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </a-spin>
</template>

<script>
import { httpAction, getAction, jsonAction } from '@/api/manage';
import moment from 'moment';

export default {
  name: 'CtMoOrganizationForm',
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    groupList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      url: {
        add: process.env.VUE_APP_CMS_CUSTOMER + '/organization/ctMoOrganization/add',
        edit: process.env.VUE_APP_CMS_CUSTOMER + '/organization/ctMoOrganization/edit',
        queryById: process.env.VUE_APP_CMS_CUSTOMER + '/organization/ctMoOrganization/queryById',
      },
    };
  },
  computed: {
    formDisabled() {
      return this.disabled;
    },
  },
  created() {
    //备份model原始值
  },
  methods: {
    add() {
      this.visible = true;
    },
    edit(record) {
      this.id = record.id;
      let params = {
        id: record.id
      };
      getAction(this.url.queryById, params).then(res => {
        if (res.success){
          this.$nextTick(() => {
            this.model = res.result;
            let data = {
              "organizationName": this.model.organizationName,
              'customerRelation': this.model.customerRelation,
              'customerManager': this.model.customerManager,
              'memberGroupId': this.model.memberGroupId,
              'memberCreateTime': this.model.memberCreateTime,
              'memberEffectiveTime': this.model.memberEffectiveTime,
            };
            this.form.setFieldsValue(data);
          });
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    submitForm() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        let formData = Object.assign(this.model, values);
        if (!err) {
          formData.memberCreateTime = moment(formData.memberCreateTime).format("YYYY-MM-DD HH:mm:ss");
          formData.memberEffectiveTime = formData.memberEffectiveTime?moment(formData.memberEffectiveTime).format("YYYY-MM-DD HH:mm:ss"):undefined;
          that.confirmLoading = true;
          let httpurl = '';
          let method = 'post';
          if (!this.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          jsonAction(httpurl, formData, method)
            .then((res) => {
              console.log(res);
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    getGroupData() {
      getAction(this.url.queryGroup).then((res) => {
        if (res.success) {
          this.groupList = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    startTimeValidate(rule, value, callback) {
      let endTime = this.form.getFieldValue('memberEffectiveTime');
      if (!value || !endTime) {
        callback();
      } else if (moment(value).isBefore(endTime)) {
        callback();
      } else {
        callback('会员开通时间需小于会员到期时间');
      }
    },
    endTimeValidate(rule, value, callback) {
      let startTime = this.form.getFieldValue('memberCreateTime');
      if (!value || !startTime) {
        callback();
      } else if (moment(startTime).isBefore(value)) {
        callback();
      } else {
        callback('会员到期时间需大于会员开通时间');
      }
    }
  }
};
</script>